/** Eternal City (living-city simulation) copy. Plain prose. */
export const cityEn = {
  'city.seoDescription': 'Walk into a living city. Everyone keeps a daily routine; follow them, talk with them, and spend a day beside people whose lives go on without you.',
  'city.intro': 'A living city. Everyone here keeps a daily routine, and time passes as you play. Click the map to walk, or use the lists beside it.',
  'city.back': 'Back to the globe',
  'city.connecting': 'Opening the city gates…',
  'city.reconnecting': 'Lost the thread. Reconnecting…',
  'city.offline': 'The city is out of reach right now. Please try again in a little while.',
  'city.signinTitle': 'Sign in to enter',
  'city.signinBody': 'Your place in the city, your journal and the people you have met are saved to your account. Time keeps passing while you play, and some errands do not wait.',
  'city.signinCta': 'Sign in',
  'city.privacy': 'How we handle this data: Privacy Policy',
  'city.blocked': 'The city is not open to this account right now. If you think that is a mistake, please contact support.',
  'city.openElsewhere': 'This city is open in another tab. Close that one or reload here.',
  'city.canvasLabel': 'Isometric map of {city}. Use the lists beside it to talk, walk and look around.',
  'city.hint': 'Click the ground to walk, or click a person to talk.',
  'city.holiday': 'Today: {name}',
  'city.here': 'You are at {place}.',
  'city.commons.empty': 'This is a shared space, and no other travellers are here right now.',
  'city.commons.here.one': 'This is a shared space, and one other traveller is here.',
  'city.commons.here.other': 'This is a shared space, and {count} other travellers are here.',
  'city.commons.peer': 'a fellow traveller',
  'city.crowd.name': 'Townsperson',
  'city.travel.ride': 'Ride to {place} (about {n} minutes)',
  'city.wares.now': 'Laid out now: {list}',
  'city.wares.none': 'Nothing laid out at this hour',
  'city.wares.few': '{name} (a few left)',
  'city.wares.last': '{name} (the last one)',
  'city.places': 'Go to a place',
  'city.goPlace': 'Go to {place}',
  'city.dialogueAnnounce': 'Choices are announced as they appear.',
  'city.people': 'Who is around',
  'city.peopleNone': 'Nobody in sight.',
  'city.talk': 'Talk',
  'city.goto': 'Walk over',
  'city.away': '{n} steps away',
  'city.scenes': 'Happening nearby',
  'city.watch': 'Join in',
  'city.props': 'Look around here',
  'city.examine': 'Look',
  'city.open': 'Open',
  'city.take': 'Take it',
  'city.menu.open': 'Open {thing}',
  'city.menu.take': 'Take what is in {thing}',
  'city.menu.walkToThing': 'Walk to {thing}',
  'city.dialogue': 'Conversation',
  'city.close': 'Close',
  'city.leave': 'Leave the conversation',
  'city.menu.talk': 'Talk to {name}',
  'city.menu.walkTalk': 'Walk over to {name}',
  'city.menu.walkTo': 'Walk to {name}',
  'city.menu.walkHere': 'Walk here',
  'city.menu.swimHere': 'Swim here',
  'city.menu.rowHere': 'Row here',
  'city.mount.down': 'Get down from {name}',
  'city.companion.home': 'Send {name} home',
  'city.rumours.title': 'Rumours board',
  'city.rumours.none': 'Nothing heard yet. Stand near townsfolk talking together, at the tavern above all, and what they say is pinned here.',
  'city.rumours.said': 'said {name}',
  'city.greet.title': 'Known by name',
  'city.greet.callMe': 'What townsfolk call you',
  'city.greet.placeholder': 'Your name',
  'city.greet.none': 'No one knows you yet. Stop and talk with someone, and next time they will greet you by name.',
  'city.greet.morning.0': 'Morning, {name}!',
  'city.greet.morning.1': 'Good morning to you, {name}.',
  'city.greet.morning.2': 'Up early, {name}?',
  'city.greet.afternoon.0': 'Afternoon, {name}.',
  'city.greet.afternoon.1': 'Good day, {name}!',
  'city.greet.afternoon.2': 'Well met again, {name}.',
  'city.greet.evening.0': 'Evening, {name}.',
  'city.greet.evening.1': 'Good evening, {name}!',
  'city.greet.evening.2': 'Off home, {name}?',
  'city.greet.night.0': 'Late to be out, {name}.',
  'city.greet.night.1': 'Mind the dark, {name}.',
  'city.greet.night.2': 'Still about, {name}?',
  'city.greet.morning.0.anon': 'Morning, friend!',
  'city.greet.morning.1.anon': 'Good morning to you.',
  'city.greet.morning.2.anon': 'Up early, friend?',
  'city.greet.afternoon.0.anon': 'Afternoon, friend.',
  'city.greet.afternoon.1.anon': 'Good day to you!',
  'city.greet.afternoon.2.anon': 'Well met again.',
  'city.greet.evening.0.anon': 'Evening, friend.',
  'city.greet.evening.1.anon': 'Good evening!',
  'city.greet.evening.2.anon': 'Off home, friend?',
  'city.greet.night.0.anon': 'Late to be out, friend.',
  'city.greet.night.1.anon': 'Mind the dark.',
  'city.greet.night.2.anon': 'Still about, friend?',
  'city.market.title': 'Market board',
  'city.market.shut': 'Nothing laid out right now.',
  'city.market.later': 'Later today:',
  'city.market.am': '{n} in the morning',
  'city.market.pm': '{n} in the afternoon',
  'city.market.eve': '{n} in the evening',
  'city.garden.title': 'Garden plots',
  'city.garden.tend': 'Tend the plot',
  'city.garden.tended': 'You pull a few weeds and water the plot.',
  'city.garden.already': 'You have already tended this plot today.',
  'city.garden.tendedNote': 'tended today',
  'city.garden.arrive': 'The {crop} here are {stage}.',
  'city.garden.crop.herbs': 'herbs',
  'city.garden.crop.apples': 'apple trees',
  'city.garden.crop.kitchen': 'kitchen greens',
  'city.garden.crop.cabbages': 'cabbages and beans',
  'city.garden.crop.wheat': 'wheat fields',
  'city.garden.stage.bare': 'bare for winter',
  'city.garden.stage.sown': 'freshly sown',
  'city.garden.stage.sprouting': 'sprouting',
  'city.garden.stage.growing': 'growing well',
  'city.garden.stage.flowering': 'in flower',
  'city.garden.stage.ripe': 'ripe and ready',
  'city.garden.stage.harvested': 'harvested for the year',
  'city.fish.title': 'Fishing',
  'city.fish.cast': 'Cast a line',
  'city.fish.go': 'Go',
  'city.fish.here': 'A good fishing spot. Cast a line from the panel.',
  'city.fish.casting': 'You cast a line and wait.',
  'city.fish.caught': 'Something bites. You land {fish}.',
  'city.fish.got.boot': 'You reel in an old boot, and toss it back.',
  'city.fish.got.weed': 'Only river weed this time.',
  'city.fish.got.nothing': 'Nothing bites. The water keeps its secrets.',
  'city.fish.casts': '{n} casts so far',
  'city.fish.none': 'No casts yet. Fish bite best at dawn and dusk, and more in spring and autumn.',
  'city.fish.spot.bank': 'river bank',
  'city.fish.spot.jetty': 'jetty',
  'city.fish.spot.bridge': 'mill bridge',
  'city.fish.name.perch': 'a perch',
  'city.fish.name.roach': 'a roach',
  'city.fish.name.trout': 'a trout',
  'city.fish.name.eel': 'an eel',
  'city.fish.name.pike': 'a pike',
  'city.fish.name.carp': 'a carp',
  'city.fish.name.minnow': 'a minnow',
  'city.fish.name.crayfish': 'a crayfish',
  'city.fish.name.boot': 'an old boot',
  'city.fish.name.weed': 'river weed',
  'city.fish.name.nothing': 'nothing',
  'city.lost.title': 'Lost and found',
  'city.lost.none': 'Nothing found yet. Townsfolk drop things in the markets, the plaza and other busy places. When you stand where something lies, pick it up here.',
  'city.lost.whose': 'belongs to {name}',
  'city.lost.find': 'Find {name}',
  'city.lost.spot': 'Something lies on the ground here: {thing}',
  'city.lost.pick': 'Pick up {thing}',
  'city.lost.picked': 'You pick up {thing}. It looks like it belongs to {name}.',
  'city.lost.give': 'Give {thing} back to {name}',
  'city.lost.thanks': '{name} is glad to have {thing} back.',
  'city.lost.thing.glove': 'a lost glove',
  'city.lost.thing.keys': 'a ring of keys',
  'city.lost.thing.locket': 'a little locket',
  'city.lost.thing.toy': 'a wooden toy',
  'city.lost.thing.scarf': 'a wool scarf',
  'city.lost.thing.purse': 'an empty purse',
  'city.lost.thing.spectacles': 'a pair of spectacles',
  'city.lost.thing.letter': 'a folded letter',
  'city.lost.thing.ribbon': 'a hair ribbon',
  'city.lost.thing.pipe': 'a clay pipe',
  'city.records.title': 'City records',
  'city.records.peak': 'Busiest today at {time}, with {n} townsfolk out and about.',
  'city.records.now': 'This hour: {out} out, {home} at home.',
  'city.records.busiest': 'Busiest quarter: {district}.',
  'city.records.outTitle': 'Townsfolk out, by hour',
  'city.records.seenTitle': 'People you saw around you, by hour',
  'city.a11y.title': 'Accessibility',
  'city.a11y.text': 'Text size',
  'city.a11y.size1': 'Normal',
  'city.a11y.size125': 'Large',
  'city.a11y.size15': 'Largest',
  'city.a11y.stillOff': 'Reduce motion',
  'city.a11y.stillOn': 'Motion reduced',
  'city.a11y.contrastOff': 'High contrast',
  'city.a11y.contrastOn': 'High contrast on',
  'city.tour.welcome.title': 'Welcome to {city}',
  'city.tour.welcome.body': 'This city lives on its own clock. People wake, work, eat and sleep whether you watch or not. Here is a short look around.',
  'city.tour.walk.title': 'Walking',
  'city.tour.walk.body': 'Tap any open ground to walk there. Your robot finds its own way around walls and through doors.',
  'city.tour.talk.title': 'Talking',
  'city.tour.talk.body': 'Tap a person to see their name and walk over. Once you are close, tap again to talk. Their words appear beside their head.',
  'city.tour.menu.title': 'Looking closer',
  'city.tour.menu.body': 'On a computer, right click anything to see what you can do there, such as read a sign, sit down or take a room.',
  'city.tour.map.title': 'The minimap',
  'city.tour.map.body': 'The small map in the corner shows roads, districts and people near you. Tap it to walk there.',
  'city.tour.panel.title': 'Your panel',
  'city.tour.panel.body': 'The side panel lists the people nearby, places you have discovered, your quests, your journal and more. On a phone, open it with the Show panel button.',
  'city.tour.keys.title': 'Moves',
  'city.tour.keys.body': 'The keyboard button shows every move your robot knows. On a phone you can turn on an action pad from there.',
  'city.tour.done.title': 'That is all',
  'city.tour.done.body': 'Enjoy {city}. You can take this tour again from the side panel.',
  'city.tour.step': '{n} of {total}',
  'city.tour.next': 'Next',
  'city.tour.back': 'Back',
  'city.tour.skip': 'Skip the tour',
  'city.tour.finish': 'Start exploring',
  'city.tour.again': 'Take the city tour again',
  'city.found.title': 'Places discovered',
  'city.found.count': '{n} of {total}',
  'city.found.none': 'Walk into a place to add it here.',
  'city.found.new': 'Discovered {place}',
  'city.board.open': 'Read the public notes board',
  'city.board.hint': 'Notes left here by other travellers. Pin up a short one of your own; no links, and up to three of yours stay up at a time.',
  'city.board.placeholder': 'Write a short note for others to find',
  'city.board.pin': 'Pin up the note',
  'city.board.loading': 'Reading the board…',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Take down your note',
  'city.board.err.signin': 'Sign in to pin up a note.',
  'city.board.err.soon': 'Wait a little before pinning up another note.',
  'city.board.err.bad': 'Notes must be plain text up to 200 characters, without links.',
  'city.board.err.down': 'The board cannot be reached right now.',
  'city.room.rent': 'Take a room at {place}',
  'city.room.move': 'Move your room to {place}',
  'city.room.yours': 'Your room at {place}',
  'city.room.decorate': 'Set something here',
  'city.room.remove': 'Take away the {thing}',
  'city.room.leave': 'Give up your room',
  'city.room.full': 'Your room has no space for more',
  'city.room.pickTitle': 'Furnish your room',
  'city.room.pickHint': 'Choose something to set on this spot. It stays in your room on this device.',
  'city.room.kind.rug': 'A woven rug',
  'city.room.kind.candle': 'A candle',
  'city.room.kind.flowers': 'A pot of flowers',
  'city.room.kind.painting': 'A painting',
  'city.room.kind.plant': 'A potted plant',
  'city.room.kind.chest': 'A little chest',
  'city.room.kind.lantern': 'A lantern',
  'city.room.kind.books': 'A few books',
  'city.busk.lute': '{name} plucks a bright tune nearby',
  'city.busk.fiddle': '{name} saws out a lively reel nearby',
  'city.busk.pipe': '{name} plays a slow air nearby',
  'city.busk.drum': '{name} beats out a dance nearby',
  'city.tail.label': 'Following {name}',
  'city.tail.title': 'Tailing {name} through the day',
  'city.tail.now': 'Now: {activity} at {place}',
  'city.tail.unknown': 'Their plans for now are unknown',
  'city.tail.next': 'Next: {place} at {time}, in {h} h {m} min',
  'city.tail.trail': 'Trailed through: {places}',
  'city.tail.stop': 'Stop following',
  'city.pins.add': 'Add a pin',
  'city.pins.tapMap': 'Tap the map to place your pin',
  'city.pins.walk': 'Walk to this pin',
  'city.pins.note': 'Pin at {x}, {y}. Add a note',
  'city.pins.noteLabel': 'Pin note',
  'city.pins.remove': 'Remove this pin',
  'city.pins.here': 'Pin this spot on the map',
  'city.compass.north': 'North',
  'city.compass.at': 'x {x}, y {y}, floor {floor}',
  'city.door.prop': 'Prop the door open',
  'city.door.close': 'Let the door swing shut',
  'city.door.unlock': 'Unlock the door',
  'city.door.lock': 'Lock the door',
  'city.books.browse': 'Browse the shelf',
  'city.books.shelf': 'Shelf at {place}',
  'city.books.book': 'Book',
  'city.books.scroll': 'Scroll',
  'city.books.prev': 'Previous',
  'city.books.back': 'Back to the shelf',
  'city.books.next': 'Next',
  'city.books.page': 'Page {n} of {of}',
  'city.sign.readSign': 'Read the sign',
  'city.sign.readPlaque': 'Read the plaque',
  'city.sign.sign': 'A painted sign',
  'city.sign.plaque': 'A plaque by the door',
  'city.district.entering': 'Now entering',
  'city.district.riverside': 'The Riverside and the Low Markets',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': 'The Lanes',
  'city.district.monastery': 'The Monastery',
  'city.district.castle': 'The Castle',
  'city.district.drains': 'The Old Drains',
  'city.district.farmlands': 'The Farmlands',
  'city.photo.enter': 'Photo mode',
  'city.photo.hint': 'Photo mode. Drag to look around; take a screenshot to keep it.',
  'city.photo.leave': 'Leave photo mode',
  'city.building.who': 'Who lives and works at {place}',
  'city.building.live': 'Lives here',
  'city.building.work': 'Works here',
  'city.building.now': 'Inside now',
  'city.building.rooms': 'Takes in {list}.',
  'city.inspect.about': 'About {name}',
  'city.inspect.close': 'Close',
  'city.inspect.unknown': 'Nobody can tell you much about {name}.',
  'city.inspect.home': 'Home',
  'city.inspect.work': 'Work',
  'city.inspect.none': 'None known',
  'city.inspect.today': 'Today',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Follow {name} through the day',
  'city.overlay.label': 'Map overlays',
  'city.overlay.crowd': 'Crowds',
  'city.overlay.light': 'Light',
  'city.overlay.noise': 'Noise',
  'city.bar.pop': '{n} live here',
  'city.bar.out': '{n} out now',
  'city.bar.season.spring': 'Spring',
  'city.bar.season.summer': 'Summer',
  'city.bar.season.autumn': 'Autumn',
  'city.bar.season.winter': 'Winter',
  'city.notebook.title': 'Heard and learned',
  'city.notebook.all': 'All',
  'city.notebook.heard': 'Heard',
  'city.notebook.learned': 'Learned',
  'city.notebook.search': 'Search your notes',
  'city.notebook.none': 'Nothing noted yet. Listen in the streets and talk to people.',
  'city.ask.title': 'Ask around',
  'city.ask.pick': 'Who are you looking for?',
  'city.ask.ask': 'Ask',
  'city.ask.passerby': 'A passer-by',
  'city.ask.nobody': 'There is no one close enough to ask. Find someone in the street.',
  'city.ask.unseen': '{asker} has not seen {who} about today.',
  'city.ask.here': '{asker} says {who} is near {place}.',
  'city.ask.go': 'Go to {who}',
  'city.weather.clear': 'Clear skies',
  'city.weather.cloudy.light': 'A few clouds',
  'city.weather.cloudy.heavy': 'Grey and overcast',
  'city.weather.rain.light': 'Light rain',
  'city.weather.rain.heavy': 'Heavy rain',
  'city.weather.fog.light': 'Morning mist',
  'city.weather.fog.heavy': 'Thick fog',
  'city.weather.snow.light': 'Light snow',
  'city.weather.snow.heavy': 'Heavy snow',
  'city.lamplighter.name': 'Lamplighter',
  'city.lamplighter.lighting': 'lighting the street lamps',
  'city.lamplighter.dousing': 'putting out the street lamps',
  'city.hourglass.title': 'Hourglass',
  'city.hourglass.stop': 'Stop the day',
  'city.hourglass.paused': 'The day stands still.',
  'city.hourglass.resume': 'Go on',
  'city.seat.bench': 'bench',
  'city.seat.chair': 'chair',
  'city.seat.sit': 'Sit on the {what}',
  'city.inside.crate': 'crate',
  'city.inside.barrel': 'barrel',
  'city.inside.title': 'Inside the {what}',
  'city.inside.look': 'Look in the {what}',
  'city.inside.holds': 'It is {fill}: {list}.',
  'city.factions.title': 'Standing in the city',
  'city.factions.wary': 'Wary',
  'city.factions.unknown': 'Unknown',
  'city.factions.noticed': 'Noticed',
  'city.factions.trusted': 'Trusted',
  'city.factions.honored': 'Honored',
  'city.factions.done': 'Errands done: {n}.',
  'city.mail.title': 'Letters',
  'city.mail.none': 'No letters yet.',
  'city.mail.from': 'From {name}',
  'city.mail.waiting': 'Waiting for a reply from {names}.',
  'city.mail.nobody': 'Help someone with an errand and you can write to them.',
  'city.mail.write': 'Write a letter',
  'city.mail.to': 'To whom',
  'city.mail.subject': 'Subject',
  'city.mail.body': 'Your letter',
  'city.mail.send': 'Send it',
  'city.mail.untitled': 'A few lines',
  'city.moth.title': "The Moth's tray",
  'city.moth.trade': 'Do the favor',
  'city.moth.yours': 'Yours now.',
  'city.spy.title': 'Quiet work',
  'city.cut.skip': 'Skip',
  'city.party.title': 'Play together',
  'city.party.blurb': 'Start a party and share its code with friends. Everyone in it sees each other anywhere in the city, not just in the shared spaces.',
  'city.party.start': 'Start a party',
  'city.party.codeLabel': 'Party code',
  'city.party.join': 'Join',
  'city.party.bad': 'A party code is four to eight letters or numbers.',
  'city.party.code': 'Your party code is {code}. Share it with friends so they can join.',
  'city.party.alone': 'Nobody else from your party is in the city right now.',
  'city.party.here': 'right beside you',
  'city.party.away': '{n} paces {dir}',
  'city.party.floor': '(floor {n})',
  'city.party.go': 'Go to',
  'city.party.leave': 'Leave the party',
  'city.party.dir.east': 'east',
  'city.party.dir.south-east': 'south-east',
  'city.party.dir.south': 'south',
  'city.party.dir.south-west': 'south-west',
  'city.party.dir.west': 'west',
  'city.party.dir.north-west': 'north-west',
  'city.party.dir.north': 'north',
  'city.party.dir.north-east': 'north-east',
  'city.print.title': 'Print a building',
  'city.print.here': '{name}: {w} by {d} cells, floors: {n}. Save it as an STL for a 3D printer.',
  'city.print.none': 'Stand in or beside a building to save it as an STL for a 3D printer.',
  'city.print.model': 'Save STL, model scale (5 mm a cell)',
  'city.print.tabletop': 'Save STL, tabletop scale (1 inch a cell)',
  'city.print.note': 'Walls, floors, doors, stairs and windows as the city draws them, on a base plate so it prints in one piece.',
  'city.print.models': 'Figures and props, ready to print:',
  'city.print.busy': 'Preparing…',
  'city.print.model.figure': 'Walker figure, 28 mm on a 25 mm base',
  'city.print.model.fountain': 'Fountain, 3 inches across',
  'city.print.model.castle-wall': 'Castle wall section, 3 inches long',
  'city.editor.stl': 'Save STL',
  'city.editor.title': 'City map editor',
  'city.editor.blurb': 'Paint a city map floor by floor: walls, streets, doors, water, ladders and named places. The check below reads it with the same map reader the living city uses. Your draft saves in this browser; export it as a file to keep or share.',
  'city.editor.name': 'Map name',
  'city.editor.tools': 'Tools',
  'city.editor.tool.pen': 'Pen',
  'city.editor.tool.rect': 'Block',
  'city.editor.tool.room': 'Room',
  'city.editor.tool.fill': 'Fill',
  'city.editor.tool.spawn': 'Start point',
  'city.editor.tiles': 'Ground',
  'city.editor.letter': 'Letter',
  'city.editor.placeName': 'Place name',
  'city.editor.addPlace': 'Add place',
  'city.editor.placeBad': 'A place needs one letter and a name.',
  'city.editor.floors': 'Floors',
  'city.editor.addFloor': 'Add floor',
  'city.editor.map': 'Map',
  'city.editor.width': 'Width',
  'city.editor.height': 'Height',
  'city.editor.new': 'New map',
  'city.editor.undo': 'Undo',
  'city.editor.export': 'Export',
  'city.editor.import': 'Import',
  'city.editor.loaded': 'Map loaded.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Check',
  'city.editor.ok': 'Reads cleanly. {walk} open cells, {reach} reachable from the start point.',
  'city.editor.placeSpots': '{name}: {n} cells',
  'city.editor.canvas': 'Map canvas',
  'city.spy.take': 'Take it',
  'city.spy.again': 'Try again',
  'city.spy.drop': 'Let it go',
  'city.spy.progress': '{n} percent there.',
  'city.spy.carrying': 'You have the note.',
  'city.spy.underway': 'Underway.',
  'city.spy.done': 'Done.',
  'city.spy.failed': 'It went wrong last time.',
  'city.menu.look': 'Look at {thing}',
  'city.menu.street': 'The street',
  'city.menu.wall': 'A wall',
  'city.continue': 'Continue',
  'city.goodbye': 'Goodbye',
  'city.board.title': 'Bounty board',
  'city.arrive.rooftops': 'You pull yourself up onto the rooftops. The lanes open out below you, and the planks between the houses creak underfoot.',
  'city.arrive.museumRoof': 'You haul yourself up the old ivy onto the museum roof. Sunwalk Plaza spreads out below you like a game board.',
  'city.crier.title': "The crier's sheet",
  'city.crier.today': 'Today is {name}.',
  'city.crier.tomorrow': '{name} is tomorrow.',
  'city.crier.coming': '{name} in {n} days.',
  'city.crier.stalls': 'Out on the stalls at first light:',
  'city.crier.notices': '{n} notices on the bounty board.',
  'city.crier.talk': 'Talk of the town:',
  'city.crier.now': 'Happening around the city right now:',
  'city.board.empty': 'Nothing pinned up today. Check back tomorrow.',
  'city.board.posted': 'Posted by {name}.',
  'city.board.postedAt': 'Posted by {name}, now at {place}.',
  'city.board.days': '{n} days left.',
  'city.board.find': 'Find them',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Talking with {name}',
  'city.journal': 'Journal',
  'city.journalNone': 'Nothing written yet.',
  'city.quests': 'Errands and threads',
  'city.questNone': 'None yet. Talk to people.',
  'city.rest': 'Rest {n} minutes',
  'city.saves.title': 'Saved games',
  'city.saves.slot': 'Slot {n}: {day} {time}, {place}',
  'city.saves.empty': 'Slot {n}: empty',
  'city.saves.save': 'Save here',
  'city.saves.load': 'Load',
  'city.saves.sure': 'Tap again to confirm',
  'city.saves.hint': 'A save keeps the whole city as it stands: where you are, the hour, the people, quests and chests. Loading puts it all back.',
  'city.restHint': 'Let time pass. You can only rest so much in an hour.',
  'city.bed.ask': 'Sleep in {bed}?',
  'city.bed.night': 'Eight hours pass while you sleep, and you rest by your game system\'s rules.',
  'city.bed.sleep': 'Sleep',
  'city.bed.notNow': 'Not now',
  'city.bed.tired': 'You are not tired yet. You can sleep again in about {n} hours.',
  'city.bed.asleep': 'Asleep. The night passes…',
  'city.bed.offer': 'Sleep here',
  'city.vitals': 'Health',
  'city.bed.woke': 'You sleep in {bed} and wake at {time}. {change}',
  'city.bed.change': '{label}: {before} to {after}.',
  'city.bed.noRest': 'The {system} rules give no recovery for rest, so nothing mends.',
  'city.bed.beds': 'Beds',
  'city.bed.demoRules': 'Rules for the bed test: {system}. Add ?rules=srd-5-2-1, zweihander or rat to the address to try another.',
  'city.messages': 'Notes',
  'city.rules': 'Game system',
  'city.rulesNarrative': 'No rules: the city as a story. Pick a system to see everyone in its numbers.',
  'city.statsFor': 'Numbers for',
  'city.sparTitle': 'Practice bout',
  'city.sparA': 'First fighter',
  'city.sparB': 'Second fighter',
  'city.sparVs': 'against',
  'city.sparRun': 'Fight',
  'city.sparNote': 'A demonstration in this system. Nobody in the city is hurt.',
  'city.sparRound': 'Round {n}.',
  'city.zoomIn': 'Zoom in',
  'city.pivot.left': 'Turn view left',
  'city.pivot.right': 'Turn view right',
  'city.pivot.north': 'Face north',
  'city.zoomOut': 'Zoom out',
  'city.centre': 'Center on me',
  'city.followOn': 'Follow on',
  'city.followOff': 'Follow off',
  'city.followOnHint': 'The camera follows you. Turn it off to pan freely.',
  'city.followOffHint': 'Pan and pinch anywhere. Tap ME to jump back to yourself.',
  'city.minimapShow': 'Show the map',
  'city.minimapHide': 'Hide the map',
  'city.minimapOpen': 'City map. Tap to open it larger.',
  'city.minimapWalk': 'City map. Tap a spot to walk there.',
  'city.minimapSmall': 'Make the map small',
  'city.minimapHint': 'Tap to walk there',
  // overheard talk between two people standing together (chatter/chatter.ts counts these per part of the day)
  'city.chatter.morning.1.a': 'Fresh bread at the corner ovens, if you hurry.',
  'city.chatter.morning.1.b': 'I smelled it two streets over. Save me a loaf.',
  'city.chatter.morning.2.a': "You're up early.",
  'city.chatter.morning.2.b': 'The bells woke me. They always do.',
  'city.chatter.morning.3.a': 'Did the carts come in through the gate?',
  'city.chatter.morning.3.b': 'Three of them, and one lost a wheel on the bridge.',
  'city.chatter.morning.4.a': 'Cold this morning.',
  'city.chatter.morning.4.b': 'The river fog will burn off by noon.',
  'city.chatter.morning.5.a': 'Where are you off to?',
  'city.chatter.morning.5.b': 'The market, before the good apples are gone.',
  'city.chatter.afternoon.1.a': 'Busy day at the stalls.',
  'city.chatter.afternoon.1.b': 'Too busy. My feet have given up on me.',
  'city.chatter.afternoon.2.a': 'Have you seen the tanner today?',
  'city.chatter.afternoon.2.b': 'He went down to the water an hour ago.',
  'city.chatter.afternoon.3.a': 'The sun is kind today.',
  'city.chatter.afternoon.3.b': 'Enjoy it. Rain is coming, I can feel it in my knee.',
  'city.chatter.afternoon.4.a': 'What did the fishmonger want for the eels?',
  'city.chatter.afternoon.4.b': 'Too much. I bought turnips instead.',
  'city.chatter.afternoon.5.a': 'Is that a new cart?',
  'city.chatter.afternoon.5.b': 'New to me. The wheels still squeak like the old one.',
  'city.chatter.evening.1.a': 'Going home already?',
  'city.chatter.evening.1.b': "Supper won't cook itself.",
  'city.chatter.evening.2.a': 'The lamps are coming on.',
  'city.chatter.evening.2.b': "Then I'm late again.",
  'city.chatter.evening.3.a': 'Will you be at the tavern tonight?',
  'city.chatter.evening.3.b': 'If my wife lets me, yes.',
  'city.chatter.evening.4.a': 'Long day.',
  'city.chatter.evening.4.b': 'They all are, this time of year.',
  'city.chatter.evening.5.a': 'Lock your shutters tonight.',
  'city.chatter.evening.5.b': 'I always do. The wind rattles them anyway.',
  'city.chatter.night.1.a': 'Who goes there?',
  'city.chatter.night.1.b': 'Only me. Put that lantern down.',
  'city.chatter.night.2.a': 'You should be asleep.',
  'city.chatter.night.2.b': 'So should you, friend.',
  'city.chatter.night.3.a': 'Did you hear something by the water?',
  'city.chatter.night.3.b': "Cats. It's always cats.",
  'city.chatter.night.4.a': 'Quiet night.',
  'city.chatter.night.4.b': "Let's keep it that way.",
  'city.chatter.any.1.a': 'Have you heard the news?',
  'city.chatter.any.1.b': 'Which news? There is always news.',
  'city.chatter.any.2.a': 'Good day to you.',
  'city.chatter.any.2.b': 'And to you.',
  'city.chatter.any.3.a': 'My cousin swears the old tower is haunted.',
  'city.chatter.any.3.b': 'Your cousin swears a lot of things.',
  'city.chatter.any.4.a': 'Prices keep going up.',
  'city.chatter.any.4.b': 'And my wages keep standing still.',
  'city.chatter.any.5.a': 'Mind the puddle there.',
  'city.chatter.any.5.b': 'Too late. Thank you anyway.',
  'city.chatter.any.6.a': 'Is that the stranger everyone mentions?',
  'city.chatter.any.6.b': "Don't stare. It's rude.",
  'city.chatter.any.7.a': 'How is your mother?',
  'city.chatter.any.7.b': "Better, thank you. She's back to scolding me.",
  'city.chatter.any.8.a': "I owe you a drink, don't I?",
  'city.chatter.any.8.b': 'Two, by my count.',
  'city.inventory.title': 'Your pack',
  'city.inventory.subtitle': 'Montkelian satchel',
  'city.inventory.close': 'Close your pack',
  'city.inventory.tabs': 'Pack sections',
  'city.inventory.tab.inventory': 'Inventory',
  'city.inventory.tab.journal': 'Journal',
  'city.inventory.tab.map': 'Map',
  'city.inventory.empty': 'Your pack is empty. Things you find on your travels will be stowed in these pockets.',
  'city.inventory.slots': 'Pockets',
  'city.inventory.slotEmpty': 'Pocket {n}, empty',
  'city.inventory.slot.headgear': 'Headgear',
  'city.inventory.slot.helmet': 'Helmet',
  'city.inventory.slot.hat': 'Hat',
  'city.inventory.slot.hood': 'Hood',
  'city.inventory.slot.amulet': 'Amulet',
  'city.inventory.slot.cloak': 'Cloak',
  'city.inventory.slot.tabard': 'Tabard',
  'city.inventory.slot.pelt': 'Pelt',
  'city.inventory.slot.armor': 'Armor',
  'city.inventory.slot.plate': 'Plate',
  'city.inventory.slot.robe': 'Robe',
  'city.inventory.slot.jerkin': 'Jerkin',
  'city.inventory.slot.hide': 'Hide',
  'city.inventory.slot.girdle': 'Girdle',
  'city.inventory.slot.belt': 'Belt',
  'city.inventory.slot.bracers': 'Bracers',
  'city.inventory.slot.gloves': 'Gloves',
  'city.inventory.slot.mainHand': 'Main hand',
  'city.inventory.slot.offHand': 'Off hand',
  'city.inventory.slot.twoHand': 'Both hands',
  'city.inventory.slot.sword': 'Sword',
  'city.inventory.slot.shield': 'Shield',
  'city.inventory.slot.staff': 'Staff',
  'city.inventory.slot.focus': 'Focus',
  'city.inventory.slot.ring': 'Ring',
  'city.inventory.slot.leggings': 'Leggings',
  'city.inventory.slot.greaves': 'Greaves',
  'city.inventory.slot.boots': 'Boots',
  'city.inventory.item.sword': 'Sword',
  'city.inventory.item.shield': 'Shield',
  'city.inventory.item.knife': 'Knife',
  'city.inventory.item.axe': 'Axe',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Cape',
  'city.inventory.item.ring': 'Ring',
  'city.inventory.class.default': 'traveller',
  'city.inventory.class.fighter': 'fighter',
  'city.inventory.class.paladin': 'paladin',
  'city.inventory.class.berserker': 'berserker',
  'city.inventory.class.wizard': 'wizard',
  'city.inventory.class.rogue': 'rogue',
  'city.inventory.slotFree': 'Empty',
  'city.inventory.gear': 'What you wear',
  'city.inventory.view': 'Show',
  'city.inventory.viewGear': 'Worn',
  'city.inventory.viewPockets': 'Pockets',
  'city.inventory.avatarHint': 'Choose a different avatar from the menu, under Avatar.',
  'city.inventory.soon.journal': 'Your journal is blank for now. Quests and notes you gather will be written here.',
  'city.inventory.soon.map': 'Your folded map will be kept here, marked with the places you have been.',
  'city.inventory.hint': 'Tap yourself to open your pack',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Choose your avatar',
  'city.avatar.robot': 'Robot',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladin',
  'city.avatarCloth': 'Cloth',
  'city.avatarClothHint': 'Capes and tabards swing as you move',
  'city.soundOn': 'Turn sound on',
  'city.soundOff': 'Turn sound off',
  'city.musicOn': 'Play music',
  'city.musicOff': 'Stop music',
  'city.walkSpeed': 'Speed',
  'city.walkSpeedLabel': 'Walking speed',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'me',
  'city.quality': 'Quality',
  'city.qualityAuto': 'Auto ({tier})',
  'city.tier.low': 'Low',
  'city.tier.medium': 'Medium',
  'city.tier.high': 'High',
  'city.robot.keys': 'Robot keys',
  'city.robot.title': 'Robot keys',
  'city.robot.intro': 'Press a key, or tap it here, and your robot acts it out for everyone nearby to see. It is for show only and changes nothing in the game.',
  'city.robot.close': 'Close',
  'city.robot.jumpNote': 'Press Space again while in the air to double jump.',
  'city.robot.spellNote': 'In spell mode, 1, 2 and 3 cast instead of attack. Cast is quick; Cast spell charges up first.',
  'city.robot.climbNote': 'Page Up and Page Down climb the stairs, ladder, ivy or drainpipe closest to you. You can also walk onto or tap a stair to take it.',
  'city.robot.walkNote': 'W, A, S and D walk north, west, south and east one step at a time. Hold a key to keep walking. The arrow keys do the same.',
  'city.robot.walk.north': 'Walk north',
  'city.robot.walk.west': 'Walk west',
  'city.robot.walk.south': 'Walk south',
  'city.robot.walk.east': 'Walk east',
  'city.stairs.label': 'Take the stairs',
  'city.stairs.up': 'Up',
  'city.stairs.down': 'Down',
  'city.stairs.goUp': 'Go up a floor',
  'city.stairs.goDown': 'Go down a floor',
  'city.robot.toggleNote': 'Weapon mode, Spell mode, Sneak, Dance and Fall down stay on until you press them again.',
  'city.robot.typing': 'The keys do nothing while you are typing in a box.',
  'city.robot.inSpell': 'Spell mode: {act}',
  'city.robot.otherwise': 'Otherwise: {act}',
  'city.robot.pad': 'Actions',
  'city.robot.padShow': 'Show the action pad',
  'city.robot.padHide': 'Hide the action pad',
  'city.robot.padTouch': '(for touch screens)',
  'city.robot.noLadder': 'No stairs or ladder close by',
  'city.robot.act.jump': 'Jump',
  'city.robot.act.double-jump': 'Double jump',
  'city.robot.act.dodge': 'Dodge',
  'city.robot.act.block': 'Block or defend',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Weapon mode',
  'city.robot.act.spell-mode': 'Spell mode',
  'city.robot.act.slash': 'Slash',
  'city.robot.act.thrust': 'Thrust',
  'city.robot.act.flurry': 'Flurry',
  'city.robot.act.cast': 'Cast',
  'city.robot.act.cast-spell': 'Cast spell',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Duck',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Sing',
  'city.robot.act.dance': 'Dance',
  'city.robot.act.barf': 'Barf',
  'city.robot.act.fall': 'Fall down or get up',
  'city.robot.act.climb-up': 'Climb up',
  'city.robot.act.climb-down': 'Climb down',
  'city.robot.act.hurt': 'Take a hit',
  'city.robot.act.kneel': 'Kneel and stand',
  'city.robot.act.bow': 'Bow',
  'city.robot.act.cheer': 'Cheer a victory',
  'city.panelShow': 'Show panel',
  'city.phone.menu': 'Menu',
  'city.phone.close': 'Close menu',
  'city.phone.view': 'Map',
  'city.phone.sound': 'Sound and pace',
  'city.phone.people': 'Find someone',
  'city.phone.more': 'Everything else',
  'city.phone.hint': 'Tap the ground to walk. Tap a person to talk.',
  'city.phone.gotIt': 'Got it',
  'city.panelHide': 'Hide panel',
  'city.canvasLabel3d': 'Map of {city} seen from above at an angle. Drag to look around, pinch or scroll to zoom, tap to walk or talk. The panel lists everyone and everything here too.',
  'city.dock.label': 'People to find',
  'city.dock.go': 'Walk to {name}',
  'city.dock.walking': 'Walking to {name}',
  'city.dock.toPlace': 'Walking to {name} at {place}',
  'city.dock.cancel': 'Tap the ground to stop',
  'city.rigDebug.open': 'Debug how {name} moves',
  'city.rigDebug.title': 'Rig debug: {name}',
  'city.rigDebug.close': 'Close',
  'city.rigDebug.move': 'Move',
  'city.rigDebug.facing': 'Facing',
  'city.rigDebug.allMoves': 'All moves',
  'city.rigDebug.allFacings': 'All facings',
  'city.rigDebug.cycling': 'Cycling, {s} s each',
  'city.rigDebug.play': 'Play',
  'city.rigDebug.pause': 'Pause',
  'city.rigDebug.back': 'Step back one frame',
  'city.rigDebug.forward': 'Step forward one frame',
  'city.rigDebug.speed': 'Speed',
  'city.rigDebug.hint': 'Pause to step frame by frame. Tap outside or press Escape to close.',
  'city.rigDebug.anim.idle': 'Idle',
  'city.rigDebug.anim.walk': 'Walk',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'View',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isometric',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'facing {dir}',
  'city.rigDebug.cell': 'row {row}, frame {col}',
  'city.rigDebug.loading': 'loading',
  'city.rigDebug.clip': 'Clip',
  'city.rigDebug.allClips': 'All clips',
  'city.rigDebug.noClips': 'No clips',
  'city.rigDebug.layers': 'Show',
  'city.rigDebug.show.model': 'Model',
  'city.rigDebug.show.bones': 'Bones',
  'city.rigDebug.show.pieces': 'Pieces',
  'city.rigDebug.boneCount': '{n} bones',
  'city.rigDebug.no3d': 'The 3D view could not start on this screen.',
  'city.rigDebug.hint3d': 'Drag to turn the camera. Pause to step frame by frame. Tap outside or press Escape to close.',
  'city.rigDebug.standIn': '{name} is shown on the {body} body here until her own is ready.',
  'city.rigDebug.archive': 'Archive',
  'city.rigDebug.archivePose': 'Pose preview: see how {name} moves',
  'city.pose.open': 'See how {name} moves',
  'city.pose.robot': 'You (robot stand-in)',
  'city.pose.you': 'You',
  'city.pose.see': 'See them move',
  'city.pose.youTitle': 'How you move',
  'city.pose.openYou': 'See how you move',
  'city.pose.title': 'How {name} moves',
  'city.pose.allTitle': 'All poses',
  'city.pose.all': 'Show all poses',
  'city.pose.one': 'Just {name}',
  'city.pose.close': 'Close',
  'city.pose.hint': 'Tap outside to close',
  'city.pose.loading': 'Loading',
  'city.pose.anim.idle': 'Idle',
  'city.pose.anim.walk': 'Walk',
  'city.pose.anim.talk': 'Talk',
  'city.pose.anim.sit': 'Sit',
  'city.pose.anim.run': 'Run',
  'city.pose.drag': 'Drag to turn',
  'city.pose.gait': 'Movement',
  'city.pose.model': '{name} in 3D',
  'city.pose.dir.SW': 'facing south-west',
  'city.pose.dir.SE': 'facing south-east',
  'city.pose.dir.NE': 'facing north-east',
  'city.pose.dir.NW': 'facing north-west',
  'city.demoLink': 'Open the renderer demo',
  'city.demoTitle': 'Renderer demo',
  'city.demoNote': 'A local preview of the 3D city with stand-in walkers. Nothing here talks to the game server.',
  'city.demoTime': 'Time of day',
  'city.demoSeason': 'Season',
  'city.demoPlay': 'Run the clock',
  'city.demoPause': 'Stop the clock',
  'city.demoTower': 'Test tower',
  'city.demoTowerNote': 'A four-storey building for checking what you can see indoors. Inside, the floors above you are cut away and anything you could not see from where you stand is greyed out. Tap a stair to take it, or use the arrows.',
  'city.demoGoTower': 'Walk to the tower',
  'city.demoFloor': 'Floor: {floor}',
  'city.demoFloor0': 'Ground',
  'city.demoFloor1': '2nd',
  'city.demoFloor2': '3rd',
  'city.demoFloor3': '4th',
  'city.demoFloor4': 'Roof',
  'city.demoWindow': '3rd floor window',
  'city.demoRoom': '3rd floor inner room',
  'city.demoUp': 'Up a floor',
  'city.demoDown': 'Down a floor',
  // Said when you walk into someone. Fixed lines for now; the dialogue AI may voice them per character later.
  'city.makeWay.polite': 'Oh, excuse me.',
  'city.makeWay.gruff': 'Hey, watch where you\'re walking.',
  'city.makeWay.immovable': 'I\'m not moving.',
  'city.makeWay.busy': 'Mind the way.',
  // Cascade Debugger (internal admin screen, read only). Prompt text itself is shown verbatim, never translated.
  'cascade.seoTitle': 'Cascade Debugger',
  'cascade.title': 'Cascade Debugger',
  'cascade.intro': 'Every prompt that shapes generated art, laid out as two family trees. The style side runs from the system down to the art director. The inheritor side is the whole taxonomy, from each shard root down to species and the lineages that sit on them. Open any row to read its full text.',
  'cascade.readOnly': 'Read only. Nothing on this screen can change a prompt.',
  'cascade.fetchedAt': 'Read from the content API at {time}',
  'cascade.refresh': 'Read again',
  'cascade.loading': 'Reading both cascades…',
  'cascade.error': 'Could not read the cascades from the content API. Try again in a moment.',
  'cascade.forbidden': 'This screen is for site admins. Your account is signed in but does not have the admin role.',
  'cascade.style.title': 'Style cascade',
  'cascade.style.subtitle': 'System, publisher, product line, setting, media type, book and art director. Each row inherits from the broader rows above it.',
  'cascade.style.focus': 'Follow the chain for',
  'cascade.style.counts': '{nodes} style rows, {edges} connections, {media} media templates',
  'cascade.taxa.title': 'Inheritor cascade',
  'cascade.taxa.subtitle': 'The full taxonomy. Each node adds its own prompt to everything it inherits from the nodes above it.',
  'cascade.taxa.group': 'Prompt group',
  'cascade.taxa.find': 'Find a taxon or lineage',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, a lineage name…',
  'cascade.taxa.counts': '{taxa} taxa, {prompts} taxon prompts, {lineages} lineages',
  'cascade.taxa.shardCounts': '{taxa} taxa, {prompts} prompt rows',
  'cascade.taxa.truncated': 'The content API capped this shard\'s prompt list, so some rows may be missing here.',
  'cascade.taxa.emptyShards': 'Shards with no taxa yet: {names}',
  'cascade.taxa.orphans': 'Lineages that point at a taxon not in any tree',
  'cascade.taxa.noOwn': 'No prompt of its own for this group.',
  'cascade.taxa.inherits': 'Inherits from above',
  'cascade.taxa.inheritsNothing': 'Nothing inherited. This is where the chain starts.',
  'cascade.taxa.through': 'Composed through this node',
  'cascade.taxa.lineages': 'Lineages on this species',
  'cascade.level.system': 'System',
  'cascade.level.publisher': 'Publisher',
  'cascade.level.product_line': 'Product line',
  'cascade.level.setting': 'Setting',
  'cascade.level.media': 'Media type',
  'cascade.level.book': 'Book',
  'cascade.level.art_director': 'Art director',
  'cascade.empty.system': 'No system style row on this chain.',
  'cascade.empty.publisher': 'No publisher style row exists yet. This level is empty.',
  'cascade.empty.product_line': 'No product line style row on this chain.',
  'cascade.empty.setting': 'No setting style row on this chain.',
  'cascade.empty.media': 'No media type templates apply to this chain.',
  'cascade.empty.book': 'No book style row hangs off this setting.',
  'cascade.empty.art_director': 'No art director is connected to this chain.',
  'cascade.missing': 'Missing level',
  'cascade.others': 'Other rows at this level ({count})',
  'cascade.mediaSpeciesNote': '{count} species templates are shown on the inheritor side, under their lineages.',
  'cascade.field.id': 'id',
  'cascade.field.scope': 'scope',
  'cascade.field.scopeId': 'scope id',
  'cascade.field.group': 'group',
  'cascade.field.mediaType': 'media type',
  'cascade.field.prompt': 'prompt',
  'cascade.field.negative': 'negative',
  'cascade.field.defaults': 'defaults',
  'cascade.field.refs': 'reference images',
  'cascade.field.chars': '{count} characters',
  'cascade.field.empty': 'empty',
  'cascade.facet.art_direction': 'Core',
  'cascade.facet.art_direction_character': 'Character',
  'cascade.facet.art_direction_scene': 'Scene',
  'cascade.facet.art_direction_interface': 'Interface',
  'cascade.facet.art_direction_cartography': 'Cartography',
  'cascade.facet.art_direction_audiobook': 'Audiobook',
  'cascade.facet.art_direction_movie': 'Movie',
  'cascade.facet.art_direction_short': 'Short',
  'cascade.facet.art_direction_tvshow': 'TV show',
  'cascade.composed.title': 'Composed for {name}',
  'cascade.composed.layers': 'Layers, broad to narrow',
  'cascade.composed.preview': 'Composed image prompt',
  'cascade.composed.previewNote': 'Assembled on this screen from the rows above in cascade order: style core, character facet, media templates, taxon traits, then the print line the generator adds in code. The live generator also adds framing and subject text.',
  'cascade.composed.negative': 'Composed negative',
  'cascade.composed.fromCode': 'added in code, not stored in any row',
  'cascade.flags.duplicates': 'Said twice',
  'cascade.flags.conflicts': 'Negative terms that also appear in the prompt',
  'cascade.flags.none': 'No repeated sentences and no negative terms that clash with the prompt.',
  'cascade.flags.in': 'in {sources}',
  'cascade.source.styleCore': 'style core',
  'cascade.source.styleCharacter': 'style character facet',
  'cascade.source.media': 'media template, {scope}',
  'cascade.source.taxon': 'taxon {rank} {value}',
  'cascade.source.printSafe': 'print line (code)',
  'cascade.rank.domain': 'domain',
  'cascade.rank.kingdom': 'kingdom',
  'cascade.rank.phylum': 'phylum',
  'cascade.rank.class': 'class',
  'cascade.rank.ordem': 'order',
  'cascade.rank.family': 'family',
  'cascade.rank.genus': 'genus',
  'cascade.rank.species': 'species',
  'cascade.rank.shard': 'shard',
}
